import { useRbTexts } from 'remote-state/applicationHooks';

interface Texts {
  title?: string;
  btnOkText?: string;
  cancelBtnText?: string;
  mainText?: string;
}

const useTexts = (): Texts => {
  const texts = useRbTexts();

  return {
    title: texts?.['spaces.generalError.prompt.title'],
    btnOkText: texts?.['spaces.generalError.prompt.okBtn'],
    cancelBtnText: texts?.['spaces.generalError.prompt.cancelBtn'],
    mainText: texts?.['spaces.generalError.prompt.details'],
  };
};

export default useTexts;
